import { render } from "./SelectArrowSvg.vue?vue&type=template&id=161ac394&bindings={}"
import script from "./SelectArrowSvg.vue?vue&type=script&lang=ts"
export * from "./SelectArrowSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script